import { useMutation } from '@aesop-fables/scrinium';
import {
  RegenerateOrgReport,
  RegenerateTeamReport,
  RegenerateGroupReport,
} from '../data/report/mutations';
import { AdminTierTypeEnum } from '../services/drillDown';

export const useReportRegeneration = (tier: AdminTierTypeEnum | undefined) => {
  const regenerateOrgReport = useMutation(new RegenerateOrgReport());
  const regenerateTeamReport = useMutation(new RegenerateTeamReport());
  const regenerateGroupReport = useMutation(new RegenerateGroupReport());

  const regenerateReport = async () => {
    switch (tier) {
      case AdminTierTypeEnum.Root:
        await regenerateOrgReport.action();
        break;
      case AdminTierTypeEnum.Organization:
        await regenerateTeamReport.action();
        break;
      case AdminTierTypeEnum.Team:
        await regenerateGroupReport.action();
        break;
    }
  };

  return { regenerateReport };
};
